<template>
  <div class="big">
    <BatchSend
      :batchSendDia.sync="batchSendDia"
      :ids="multipleSelection"
      interfaceName="batchSendPreSms"
      :user_type="2"
      @refreshList="getList"
    ></BatchSend>
    <DocMsg :isFlag="doc_msg" :doctorId="doctorId"></DocMsg>
    <ReturnVisit
      :isFlag="return_visit"
      :businessId="preId"
      :visitType="visitType"
      :visitName="visitName"
      :typeList="typeList"
      :activeIndexDia="activeIndexDia"
      :sms_type="2"
      @refreshList="getList"
    ></ReturnVisit>
    <div class="page_title">处方记录</div>
    <div style="padding: 20px; border-radius: 5px">
      <div class="container">
        <div style="padding: 0 24px 0 24px" class="big">
          <div class="searchbox">
            <div class="item">
              <span class="searchtitle">处方号</span>
              <el-input
                placeholder="请输入"
                v-model="pre_id"
                class="inputclass"
                @change="search"
                clearable
              ></el-input>
            </div>
            <div class="item">
              <span class="searchtitle">订单编号</span>
              <el-input
                placeholder="请输入"
                v-model="order_sn"
                class="inputclass"
                @change="search"
                clearable
              ></el-input>
            </div>
            <!-- <div class="item">
              <span class="searchtitle">处方类型</span>
              <el-select
                v-model="pre_group"
                placeholder="请选择"
                class="inputclass"
                clearable
                @change="search"
              >
                <el-option
                  label="全部"
                  :value="''"
                ></el-option>
                <el-option
                  label="中药材"
                  :value="1"
                ></el-option>
                <el-option
                  label="养生方"
                  :value="2"
                ></el-option>
                <el-option
                  label="成药"
                  :value="3"
                ></el-option>
              </el-select>
            </div> -->
            <div class="item">
              <span class="searchtitle">患者姓名</span>
              <el-input
                placeholder="请输入"
                v-model="user_name"
                class="inputclass"
                @change="search"
                clearable
              ></el-input>
            </div>

            <div class="item">
              <span class="searchtitle">医生姓名</span>
              <el-input
                placeholder="请输入"
                v-model="doctor_name"
                class="inputclass"
                @change="search"
                clearable
              ></el-input>
              <el-checkbox
                v-model="is_look"
                :true-label="1"
                :false-label="0"
                style="margin-left: 4px"
                @change="search"
                >不看</el-checkbox
              >
            </div>

            <div class="item">
              <span class="searchtitle">推荐人姓名</span>
              <el-input
                placeholder="请输入"
                v-model="recommender_name"
                class="inputclass"
                @change="search"
                clearable
              ></el-input>
            </div>
            <div class="item">
              <span class="searchtitle">医生手机号</span>
              <el-input
                placeholder="请输入"
                v-model="phone"
                class="inputclass"
                clearable
                @change="search"
              ></el-input>
            </div>

            <div class="item">
              <span class="searchtitle">处方状态</span>
              <el-select
                v-model="pre_status"
                placeholder="请选择"
                class="inputclass"
                clearable
                @change="search"
              >
                <el-option label="全部" :value="0"></el-option>
                <el-option label="待取药" :value="1"></el-option>
                <el-option label="待审方" :value="2"></el-option>
                <el-option label="已通过" :value="3"></el-option>
                <el-option label="已抓药" :value="4"></el-option>
                <el-option label="已作废" :value="5"></el-option>
              </el-select>
            </div>
            <div class="item">
              <span class="searchtitle">处方来源</span>
              <el-select
                v-model="pre_type"
                placeholder="请选择"
                class="inputclass"
                clearable
                multiple
                @change="search"
              >
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
            <div class="item">
              <span class="searchtitle">订单状态</span>
              <el-select
                v-model="order_status"
                placeholder="请选择"
                class="inputclass"
                clearable
                @change="search"
              >
                <el-option label="全部" :value="0"></el-option>
                <el-option label="待审核" :value="1"></el-option>
                <el-option label="待发货" :value="2"></el-option>
                <el-option label="待收货" :value="3"></el-option>
                <el-option label="已完成" :value="4"></el-option>
                <el-option label="不通过" :value="5"></el-option>
                <el-option label="平台退款" :value="6"></el-option>
              </el-select>
            </div>
            <div class="item">
              <span class="searchtitle">开方时间</span>
              <el-date-picker
                v-model="date"
                type="daterange"
                range-separator="~"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                @change="search"
                clearable
                style="width: 225px; margin-left: 12px"
              ></el-date-picker>
            </div>

            <div class="item">
              <span class="searchtitle">是否已回访</span>
              <span>
                <el-radio-group v-model="is_visit" @change="search">
                  <el-radio :label="''">全部</el-radio>
                  <el-radio :label="1">是</el-radio>
                  <el-radio :label="0">否</el-radio>
                </el-radio-group>
              </span>
            </div>
            <template v-if="is_visit == 1">
              <div class="item">
                <span class="searchtitle">已回访类型</span>
                <el-select
                  class="input_width"
                  v-model="visit_type"
                  placeholder="请选择"
                  clearable
                  @change="search"
                >
                  <el-option
                    v-for="item in typeList"
                    :key="item.visit_type"
                    :label="item.value"
                    :value="item.visit_type"
                  >
                  </el-option>
                </el-select>
              </div>

              <div class="item">
                <span class="searchtitle">已回访时间</span>
                <el-date-picker
                  v-model="visit_time"
                  type="daterange"
                  range-separator="到"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                  value-format="yyyy-MM-dd"
                  @change="search"
                  clearable
                ></el-date-picker>
              </div>
            </template>
            <div class="item">
              <el-button
                type="info"
                style="background-color: #eceff2; color: #747981"
                @click="search"
                size="medium"
                >查询</el-button
              >
              <el-button
                type="primary"
                @click="batchSendBtn"
                :disabled="
                  module_id_array[0] ? !module_id_array.includes('1564') : false
                "
                size="medium"
                >批量发送短信</el-button
              >
            </div>
            <!-- <div class="item">
              <span class="searchtitle">药品剂型</span>
              <el-select
                v-model="drug_type"
                placeholder="请选择"
                class="inputclass"
                clearable
                @change="search"
              >
                <el-option
                  v-for="item in options2"
                  :key="item.drug_type"
                  :label="item.drug_type_name"
                  :value="item.drug_type"
                ></el-option>
              </el-select>
            </div> -->
          </div>
          <div style="border: solid 1px #c9cbd6">
            <el-table
              ref="multipleTable"
              :data="tableData"
              tooltip-effect="dark"
              style="width: 100%; min-width: 1000px"
              :header-cell-style="{ background: '#F5F5F5' }"
              @selection-change="handleSelectionChange"
            >
              <el-table-column type="selection" width="55"> </el-table-column>
              <el-table-column label="处方号" prop="pre_id"></el-table-column>
              <el-table-column
                label="订单编号"
                prop="order_sn"
              ></el-table-column>
              <el-table-column
                label="开方时间"
                prop="create_time"
                width="100px"
              ></el-table-column>
              <el-table-column label="患者信息">
                <template slot-scope="scope">
                  <div>{{ scope.row.user_name }}</div>
                  <div>
                    <span v-if="scope.row.sex == 1">男</span>
                    <span v-if="scope.row.sex == 2">女</span>
                    <span style="margin-left: 10px">{{ scope.row.age }}</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="医生信息">
                <template slot-scope="scope">
                  <div
                    @click="showDocMsg(scope.row.doctor_id)"
                    style="cursor: pointer"
                  >
                    {{ scope.row.doctor_name }}
                  </div>
                  <div>
                    <span v-if="scope.row.d_sex == 1">男</span>
                    <span v-if="scope.row.d_sex == 2">女</span>
                    <span style="margin-left: 10px">{{ scope.row.title }}</span>
                  </div>
                  <div>{{ scope.row.phone }}</div>
                </template>
              </el-table-column>
              <el-table-column prop="pre_group">
                <template slot="header">
                  <div>处方类型/</div>
                  <div>药品剂型</div>
                </template>
                <template slot-scope="scope">
                  <div>
                    {{ scope.row.drug_type_name }}
                  </div>
                  <div v-if="scope.row.drug_machining">代煎</div>
                  <div v-if="scope.row.pre_num > 1">
                    ({{ scope.row.pre_sort }} / {{ scope.row.pre_num }})
                  </div>
                </template>
              </el-table-column>
              <!-- <el-table-column label="处方来源">
                <template slot-scope="scope">
                  <span v-if="scope.row.pre_type == 1">
                    <span v-if="scope.row.web_pre_type == 1">web问诊开方</span>
                    <span v-else>问诊开方</span>
                  </span>
                  <span v-if="scope.row.pre_type == 2">
                    <span v-if="scope.row.web_pre_type == 1">web在线开方</span>
                    <span v-else>直接开方</span>
                  </span>
                  <span v-if="scope.row.pre_type == 3">重新开方</span>
                  <span v-if="scope.row.pre_type == 4">云诊所开方</span>
                  <span v-if="scope.row.pre_type == 5">手机号开方</span>
                  <span v-if="scope.row.pre_type == 6">微信开方</span>
                  <span v-if="scope.row.pre_type == 7">视频开方</span>
                  <span v-if="scope.row.pre_type == 8">按方购药</span>
                  <span v-if="scope.row.pre_type == 9">拍方购药</span>
                  <span v-if="scope.row.pre_type == 10">开放平台开方</span>
                  <span v-if="scope.row.pre_type == 11">医生拍照开方</span>
                  <div v-if="scope.row.org_name">{{ scope.row.org_name }}</div>
                </template>
              </el-table-column> -->

              <el-table-column label="处方来源">
                <template slot-scope="scope">
                  <span v-if="scope.row.pre_type == 1">
                    <span v-if="scope.row.web_pre_type == 1">web问诊开方</span>
                    <span v-else>问诊开方</span>
                  </span>
                  <span v-if="scope.row.pre_type == 2">
                    <span v-if="scope.row.web_pre_type == 1">web在线开方</span>
                    <span v-else>直接开方</span>
                  </span>
                  <span v-if="scope.row.pre_type == 3">重新开方</span>
                  <span v-if="scope.row.pre_type == 4">云诊所开方</span>
                  <span v-if="scope.row.pre_type == 5">
                    <span v-if="scope.row.web_pre_type == 1"
                      >web手机号开方</span
                    >
                    <span v-else>手机号开方</span>
                  </span>
                  <span v-if="scope.row.pre_type == 6">
                    <span v-if="scope.row.web_pre_type == 1">web微信开方</span>
                    <span v-else>{{
                      !scope.row.is_wx_pre ? "微信开方" : "微信拍照"
                    }}</span>
                  </span>
                  <span v-if="scope.row.pre_type == 7">视频开方</span>
                  <span v-if="scope.row.pre_type == 8">按方购药</span>
                  <span v-if="scope.row.pre_type == 9">拍方购药</span>
                  <span v-if="scope.row.pre_type == 10">开放平台开方</span>
                  <span v-if="scope.row.pre_type == 11">医生拍照开方</span>
                  <span v-if="scope.row.pre_type == 12">医生协定方开方</span>

                  <div v-if="scope.row.org_name">{{ scope.row.org_name }}</div>
                </template>
              </el-table-column>
              <el-table-column label="处方状态">
                <template slot-scope="scope">
                  <span v-if="scope.row.pre_status == 1">待取药</span>
                  <span v-if="scope.row.pre_status == 2">待审方</span>
                  <span v-if="scope.row.pre_status == 3">已通过</span>
                  <span v-if="scope.row.pre_status == 4">已抓药</span>
                  <span
                    v-if="
                      scope.row.pre_status == 5 ||
                      scope.row.pre_status == 6 ||
                      scope.row.pre_status == 7 ||
                      scope.row.pre_status == 8
                    "
                    >已失效</span
                  >
                </template>
              </el-table-column>
              <el-table-column label="订单状态">
                <template slot-scope="scope">
                  <span v-if="scope.row.order_status == 1">待审核</span>
                  <span v-if="scope.row.order_status == 2">待发货</span>
                  <span v-if="scope.row.order_status == 3">待收货</span>
                  <span v-if="scope.row.order_status == 4">已完成</span>
                  <span v-if="scope.row.order_status == 5">不通过</span>
                  <span v-if="scope.row.order_status == 6">平台退款</span>
                </template>
              </el-table-column>
              <el-table-column
                label="是否已回访"
                prop="is_return"
                width="220px"
              >
              </el-table-column>
              <el-table-column label="操作" width="220">
                <template slot-scope="scope">
                  <el-button
                    @click="toReturn(scope.row.pre_id)"
                    type="text"
                    :disabled="
                      module_id_array[0]
                        ? !module_id_array.includes('1315')
                        : false
                    "
                    >回访</el-button
                  >
                  <el-button
                    @click="toReturnList(scope.row.pre_id)"
                    type="text"
                    :disabled="
                      module_id_array[0]
                        ? !module_id_array.includes('1308')
                        : false
                    "
                    >回访记录</el-button
                  >
                  <el-button
                    @click="toDetail(scope.row.pre_id)"
                    type="text"
                    :disabled="
                      module_id_array[0]
                        ? !module_id_array.includes('56')
                        : false
                    "
                    >查看处方</el-button
                  >
                  <!-- <router-link
                    target="_blank"
                    :to="{
                      path: '/home/yewu/chufangdetail',
                      query: { pre_id: scope.row.pre_id },
                    }"
                    >About Page</router-link
                  > -->
                  <!-- <el-button @click="setIsReturn(scope.row.pre_id)"
                             type="text"
                             v-if="scope.row.is_return == 0&&laber_code!='pre_0'"
                             :disabled="
                  module_id_array[0] ? !module_id_array.includes('1307') : false
                ">标记为已回访</el-button> -->
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div style="margin-top: 24px">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="pagesize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="totalNum"
            ></el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import dayjs from "dayjs";
import DocMsg from "../../../components/common/DocMsg.vue";
import ReturnVisit from "../../../components/common/ReturnVisit.vue";
import BatchSend from "@/components/batchSend/index.vue";
export default {
  data() {
    return {
      batchSendDia: false,
      multipleSelection: [],
      currentPage: 1,
      pagesize: 10,
      totalNum: 0,
      tableData: [],
      date: [],
      pre_id: "",
      order_sn: "",
      doctor_name: "",
      phone: "",
      user_name: "",
      pre_status: "",
      pre_type: [],
      is_look: "",
      recommender_name: "",
      order_status: "",
      // laber_code: 'pre_0',
      is_visit: "",
      visit_type: "",
      visit_time: [],
      options: [
        {
          value: 1,
          label: "问诊开方",
        },
        {
          value: 2,
          label: "直接开方",
        },
        {
          value: 3,
          label: "重新开方",
        },
        {
          value: 4,
          label: "云诊所开方",
        },
        {
          value: 5,
          label: "手机号开方",
        },
        {
          value: 6,
          label: "微信开方",
        },
        {
          value: 7,
          label: "视频问诊开方",
        },
        {
          value: 8,
          label: "按方购药",
        },
        {
          value: 9,
          label: "拍方购药",
        },
        {
          value: 10,
          label: "开放平台开方",
        },
        {
          value: 11,
          label: "医生拍照开方",
        },
        {
          value: 12,
          label: "web问诊开方",
        },
        {
          value: 13,
          label: "web在线开方",
        },
        {
          value: 14,
          label: "web手机号开方",
        },

        {
          value: 15,
          label: "web微信开方",
        },
        {
          value: 16,
          label: "医生协定方开方",
        },
      ],
      options2: [],
      typeList: [],
      is_test: 2,
      selection: [],
      doc_msg: false,
      doctorId: "",
      return_visit: false,
      preId: 0,
      visitName: "prescription",
      visitType: 3,
      activeIndexDia: "1",
    };
  },
  components: {
    DocMsg,
    ReturnVisit,
    BatchSend,
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
  },
  created() {
    this.getVisitType();
    this.initDate();
    this.getDrugTypeList();
  },
  methods: {
    initDate() {
      const end = new Date();
      const start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
      this.date = [start, end];
      this.getList();
    },
    //医生信息概要
    showDocMsg(pre_id) {
      this.doctorId = pre_id;
      this.doc_msg = !this.doc_msg;
    },
    //获取回访类型
    getVisitType() {
      this.axios
        .post("platform/Clientreview/getVisitType", {
          visit_type: "prescription",
        })
        .then((res) => {
          if (res.code == 0) {
            this.typeList = res.data.list;
          }
        });
    },
    //获取列表
    getList() {
      let data = {
        page: this.currentPage,
        pageNumber: this.pagesize,
        pre_id: this.pre_id,
        order_sn: this.order_sn,
        doctor_name: this.doctor_name,
        phone: this.phone,
        user_name: this.user_name,
        pre_status: this.pre_status,
        pre_type: this.pre_type.join(","),
        order_status: this.order_status,
        laber_code: this.laber_code,
        is_visit: this.is_visit,
        is_look: this.is_look,
        recommender_name: this.recommender_name,
      };
      if (this.date && this.date.length > 0) {
        data.start_time = dayjs(this.date[0]).format("YYYY-MM-DD");
        data.end_time = dayjs(this.date[1]).format("YYYY-MM-DD");
      }
      if (this.is_visit == 1) {
        data.visit_start_time = this.visit_time ? this.visit_time[0] : "";
        data.visit_end_time = this.visit_time ? this.visit_time[1] : "";
        data.visit_type = this.visit_type;
      }
      this.axios.post("platform/Clientreview/preList", data).then((res) => {
        if (res.code == 0) {
          this.tableData = res.data.list.map((item) => {
            item.create_time = dayjs
              .unix(item.create_time)
              .format("YYYY-MM-DD HH:mm");
            return item;
          });
          this.totalNum = res.data.total;
        }
      });
    },
    //获取平台开方可以选择的剂型列表
    getDrugTypeList() {
      let platform_type = 3;
      this.axios
        .post("platform/photograph/getDrugTypeList", { platform_type })
        .then((res) => {
          this.options2 = res.data.list;
        });
    },
    //搜索
    search() {
      this.currentPage = 1;
      this.getList();
    },
    //每页数据
    handleSizeChange(size) {
      this.pagesize = size;
      this.getList();
    },
    //翻页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    //设置标记已回访
    setIsReturn(pre_id) {
      let data = {
        laber_code: this.laber_code,
        visit_type: "prescription",
        visit_type_id: pre_id,
      };
      this.axios.post("platform/Clientreview/setIsReturn", data).then((res) => {
        if (res.code == 0) {
          this.$message.success("已标记为已回访");
        }
        this.getList();
      });
    },
    //回访
    toReturn(pre_id) {
      this.preId = pre_id;
      this.activeIndexDia = "1";
      this.return_visit = !this.return_visit;
    },
    //回访记录
    toReturnList(pre_id) {
      this.preId = pre_id;
      this.activeIndexDia = "2";
      this.return_visit = !this.return_visit;
    },
    // 批量发送短信
    handleSelectionChange(val) {
      this.multipleSelection = val.map((item) => item.pre_id);
    },
    batchSendBtn() {
      if (!this.multipleSelection.length) {
        this.$message.warning("请选择");
        return;
      }
      this.batchSendDia = true;
    },
    //查看详情
    toDetail(pre_id) {
      window.open(`#/home/yewu/chufangdetail?pre_id=${pre_id}`, "_blank");
    },
  },
};
</script>
<style lang="scss" scoped>
.container {
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 205px);
  padding-bottom: 20px;
}
.noneline {
  border: 0;
  padding: 0 20px;
}
.title {
  font-size: 16px;
  width: 90px;
}
.searchbox {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  .item {
    margin-right: 16px;
    margin-top: 16px;
    display: flex;
    align-items: center;
  }
  .inputclass {
    width: 160px;
  }
  .searchtitle {
    display: inline-block;
    width: 70px;
    text-align: right;
    box-sizing: border-box;
    margin-right: 8px;
  }
}
</style>
